/* --------------------------------------------
HappyNewYear!
-------------------------------------------- */
import * as Vivus from 'vivus';
import anime from 'animejs/lib/anime.es.js';

import {
  no_scroll,
  return_scroll
} from '../common/_common';

let moveObj_01 = $("#moveObject_01");

let loading = $('#loading');
let vivusObj = $('#vivusObject');
let drop = $('#drop');
let moveBg = $('#moveBg');
let bgCow = $('#bgCow');
let scrollDown = $('#scrollDown');
let logoObj = $('#logoMoveObject object');
let yearObj = $('#yearMoveObject object');

export function mainAnimationFunc() {

  $('body').addClass('fixed');
  $('body').css('overflow', 'hidden');
  $('html,body').animate({
    scrollTop: 0
  }, '0');
  no_scroll();
  loading.css('opacity', '0');
  vivusObj.css('opacity', '1');
  new Vivus('vivusObject', {
    delay: 100,
    duration: 300,
    animTimingFunction: Vivus.EASE,
    start: 'autostart',
  }, (obj) => {
    showFunc();
  });

  function showFunc() {
    vivusObj.css('opacity', '0');
    logoObj.css('opacity', '1');
    setTimeout(() => {
      moveObj_01.addClass('bound');
    }, 2000);
    setTimeout(() => {
      logoObj.addClass('move');
    }, 3000);
    setTimeout(() => {
      yearObj.addClass('move');
    }, 4000);
    setTimeout(() => {
      waveMove();
    }, 6000);
  }

  //  function logoMove() {
  //    var moveAnimationEl = document.querySelector('#logoMoveObject');
  //    var shapeEls = moveAnimationEl.querySelectorAll('object');
  //
  //    function animateShape(el) {
  //
  //      function createKeyframes(value) {
  //        var keyframes = [];
  //        for (var i = 0; i < 5; i++) keyframes.push({
  //          value: value
  //        });
  //        return keyframes;
  //      }
  //
  //      var animation = anime.timeline({
  //          targets: el,
  //          easing: 'linear',
  //        })
  //        .add({
  //          duration: function () {
  //            return anime.random(800, 1200);
  //          },
  //          translateX: function () {
  //            return anime.random(-600, 600);
  //          },
  //          translateY: function () {
  //            return anime.random(-220, 220);
  //          },
  //          rotate: function () {
  //            return anime.random(-90, 90);
  //          },
  //        })
  //        .add({
  //          duration: 4000,
  //          translateX: createKeyframes(function (el) {
  //            return anime.random(-300, 300);
  //          }),
  //          translateY: createKeyframes(function (el) {
  //            return anime.random(-110, 110);
  //          }),
  //          rotate: createKeyframes(function () {
  //            return anime.random(-60, 60);
  //          }),
  //        })
  //        .add({
  //          duration: 2000,
  //          translateX: 0,
  //          translateY: 0,
  //          rotate: 0,
  //        });
  //    }
  //
  //    for (var i = 0; i < shapeEls.length; i++) {
  //      animateShape(shapeEls[i]);
  //    }
  //  }

  //  function yearMove() {
  //    var moveAnimationEl = document.querySelector('#yearMoveObject');
  //    var shapeEls = moveAnimationEl.querySelectorAll('object');
  //    var fadeOutPos = ['100vw', '-100vw'];
  //
  //    function animateShape(el) {
  //
  //      function createKeyframes(value) {
  //        var keyframes = [];
  //        for (var i = 0; i < 3; i++) keyframes.push({
  //          value: value
  //        });
  //        return keyframes;
  //      }
  //
  //      var animation = anime.timeline({
  //          targets: el,
  //          easing: 'linear',
  //          complete: function (anim) {
  //            setTimeout(() => {
  //              drop.addClass('drop');
  //            }, 2000);
  //            setTimeout(() => {
  //              waveMove();
  //            }, 4500);
  //          },
  //        })
  //        .add({
  //          duration: function () {
  //            return anime.random(600, 1000);
  //          },
  //          translateX: function () {
  //            return anime.random(-300, 300);
  //          },
  //          translateY: function () {
  //            return anime.random(-110, 110);
  //          },
  //          rotate: function () {
  //            return anime.random(-60, 60);
  //          },
  //          delay: function () {
  //            return anime.random(100, 300);
  //          },
  //        })
  //        .add({
  //          duration: 2000,
  //          translateX: createKeyframes(function (el) {
  //            return anime.random(-300, 300);
  //          }),
  //          translateY: createKeyframes(function (el) {
  //            return anime.random(-110, 110);
  //          }),
  //          rotate: createKeyframes(function () {
  //            return anime.random(-60, 60);
  //          }),
  //        })
  //        .add({
  //          duration: 1000,
  //          easing: 'easeOutSine',
  //          translateX: 0,
  //          translateY: 0,
  //          rotate: 0,
  //        });
  //    }
  //
  //    for (var i = 0; i < shapeEls.length; i++) {
  //      animateShape(shapeEls[i]);
  //    }
  //  }

  function waveMove() {
    drop.addClass('drop');
    moveBg.addClass('move');
    bgCow.addClass('show');
    setTimeout(() => {
      $('#happyNewYear').addClass('active');
    }, 10000);
    setTimeout(() => {
      scrollDown.addClass('show');
      //$('body').removeClass('fixed');
      //return_scroll();
    }, 12000);
    setTimeout(() => {
      //scrollDown.addClass('show');
      $('body').removeClass('fixed');
      $('body').css('overflow', 'auto');
      return_scroll();
    }, 13000);
  }

}

export function contentFadeInFunc() {
  $('.inView').on('inview', function () {
    setTimeout(() => {
      $(this).addClass('fadeIn');
    }, 500);
  });
}
